import * as React from "react"
import type { SVGProps } from "react"
const SvgVideo = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M4 20.14q-.82 0-1.41-.58A2 2 0 0 1 2 18.13v-12q0-.82.59-1.41A2 2 0 0 1 4 4.14h12q.83 0 1.41.59.6.6.59 1.41v4.5l3.15-3.15q.25-.24.55-.12t.3.47v8.6q0 .36-.3.48t-.55-.13L18 13.64v4.5q0 .82-.59 1.42a2 2 0 0 1-1.41.58zm0-2h12v-12H4z" />
  </svg>
)
export default SvgVideo
